var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatchmansStation01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.56,11.54H4.47V4.46h7.09V11.54z M4.97,11.04h6.09V4.96H4.97V11.04z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.08,9.54L6.35,6.67h0.39l0.34,1.45C7.17,8.48,7.25,8.84,7.3,9.11h0.01c0.05-0.29,0.14-0.63,0.23-1 l0.38-1.45h0.39l0.35,1.46c0.08,0.34,0.16,0.68,0.2,0.98h0.01C8.93,8.79,9.01,8.47,9.1,8.12l0.38-1.45h0.38L9.05,9.54H8.66 L8.3,8.05C8.21,7.68,8.15,7.4,8.11,7.11H8.1C8.05,7.39,7.99,7.67,7.88,8.05L7.47,9.54H7.08z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchmansStation01);
export default __webpack_public_path__ + "static/media/WatchmansStation-01.b6ab735e27d3417d28ffcbbce7745003.svg";
export { ForwardRef as ReactComponent };